// eslint-disable-next-line import/extensions
import { constantsModule } from './constants';

constantsModule.constant('uiMessages', {
    FileWrongExtension: 'File type is not valid.  Please select another document.',
    DocExceedsMaxSize: 'Document exceeds maximum allowed size.',
});
